export default __webpack_public_path__ + "static/media/P10022.71bd29c6.png";